import gql from 'graphql-tag'

/**
 * GraphQL fragment with every PAMM offer field the hierarchical tree view needs.
 *
 * Shared by both the Money Manager (`pammOffers`) and Agent (`pammAgentOffers`) queries
 * so the two pages produce an identical `PammOfferType` shape for `PammOffersTree`.
 */
export const PAMM_OFFER_TREE_FIELDS = gql`
  fragment PammOfferTreeFields on PammOfferType {
    id
    name
    activeInvestmentCount
    currency
    managerId
    managerName
    totalDepositSum
    skygroundAccountId
    settings {
      agentChain {
        agentId
        client {
          id
        }
      }
      tradingInterval {
        type
        count
      }
      minDeposit
      minInitialInvestment
      minWithdrawal
      performanceFees {
        levels {
          level
          value
        }
        mode
      }
    }
  }
`
